function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.72 13.805h4.057L16.72 9.783v4.022zm-5.11-5.11h5.865l4.39 4.39v8.78c0 .399-.146.738-.439 1.019a1.447 1.447 0 01-1.036.422h-8.78c-.398 0-.744-.141-1.036-.422a1.36 1.36 0 01-.44-1.019l.036-11.73c0-.399.14-.738.421-1.019.281-.281.62-.422 1.019-.422z",
  fill: "#4A4A4A",
  fillRule: "evenodd"
})));